import { CheckoutPage } from '@/lib/checkoutRoutes';

/** Soft-nav overlay / listing-gate skeleton must not block the previous page forever. */
export const SOFT_NAV_SKELETON_TIMEOUT_MS = 4000;

const CHECKOUT_PATHS = new Set(Object.values(CheckoutPage).map((page) => `/${page}`));

/**
 * Dedicated app routes that never used segment loading.tsx skeletons.
 * Soft-nav to these must not flash the listing/product overlay.
 */
const SKIP_EXACT = new Set([
  '/',
  '/404',
  '/giris-yap',
  '/kayit-ol',
  '/sepetim',
  '/sepet-uyelik',
  '/siparis-alindi',
  '/siparis-odeme-hatasi',
  '/sifremi-unuttum',
  '/log-out',
  '/mobil-menu',
  '/mobile-auth',
  '/uygulama',
  '/uygulama-indir',
  '/uygulama-puanla',
  '/hediye-202506',
  '/sikca-sorulan-sorular',
  '/video-mesaj-aydinlatma-metni',
  '/gelin-arabasi-susleme',
  '/oner-kazan',
  '/acilis',
]);

const SKIP_PREFIXES = [
  '/api',
  '/profilim',
  '/satin-al',
  '/blog',
  '/oner-kazan',
  '/sifre-kurtarma',
  '/sitemap',
  '/_next',
];

export type InstantRouteTransitionKind = 'list' | 'product';

function matchesSkipPrefix(path: string, prefix: string): boolean {
  return path === prefix || path.startsWith(`${prefix}/`);
}

/**
 * Which skeleton (if any) to show for a soft navigation target.
 * Mirrors the old segment loading.tsx coverage without streaming a 200 before notFound().
 */
export function getInstantRouteTransitionKind(pathname: string): InstantRouteTransitionKind | null {
  if (!pathname) return null;

  const path = pathname.endsWith('/') && pathname.length > 1 ? pathname.slice(0, -1) : pathname;

  if (SKIP_EXACT.has(path)) return null;
  if (CHECKOUT_PATHS.has(path)) return null;

  for (const prefix of SKIP_PREFIXES) {
    if (matchesSkipPrefix(path, prefix)) return null;
  }

  if (path.startsWith('/urun/')) return 'product';

  // Explicit former loading.tsx list routes + catch-all marketing/category URLs.
  if (
    path.startsWith('/bolge/') ||
    path.startsWith('/urunler') ||
    path.startsWith('/kampanya/') ||
    path === '/cicek' ||
    path.startsWith('/cicek/') ||
    path.startsWith('/kategori/')
  ) {
    return 'list';
  }

  // [...slug] category / product / landing soft-navs (had [...slug]/loading.tsx).
  return 'list';
}
